<template>
  <!-- MODAL DE AUDITORIA DE CAMBIOS -->
  <jll-modal v-if="auditLog" :value="!!auditLog" :header="$t('common.modalAudit.lblTitle')" show-footer @input="$store.dispatch('auditLogModule/closeModal')" class="modal-position-fixed">
    <p v-if="!auditLog || !auditLog.length">
      <b>{{ $t('common.modalAudit.msgNoChanges') }}</b>
    </p>
    <template v-else>
      <div v-for="(entry, index) in mutatedAuditLogData" :key="index" class="panel panel-primary modal-audit-log">
        <div class="panel-body">
          <div class="mb-3 pl-1">
            <comps-audit-log-modal-table-title :data="entry" />
          </div>

          <div class="table-responsive">
            <table class="table table-condensed table-striped table-bordered table-hover small" border="1">
              <thead>
                <tr class="bg-primary">
                  <th class="bg-dark text-light">{{ $t('common.modalAudit.table.colField') }}</th>
                  <th class="bg-dark text-light">{{ $t('common.modalAudit.table.colBefore') }}</th>
                  <th class="bg-dark text-light">{{ $t('common.modalAudit.table.colAfter') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(field, index) in entry.FieldsAudit" :key="index">
                  <td>
                    <strong>{{ field.Field }}</strong>
                  </td>
                  <td>{{ field.Before }}</td>
                  <td>{{ field.After }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </jll-modal>
</template>

<script>
import compsAuditLogModalTableTitle from '@/components/pix/compsAuditLogModalTableTitle.vue';
import JllModal from 'pix-modal/src/lib-components/JllModal.vue';
import momentMixin from '@/mixins/moment.mixin.js';

export default {
  name: 'pix-audit-log-modal',

  mixins: [momentMixin],

  components: { JllModal, compsAuditLogModalTableTitle },

  computed: {
    auditLog() {
      return this.$store.getters['auditLogModule/getAuditLog'];
    },

    mutatedAuditLogData() {
      if (!this.auditLog.length) return;
      const dateAuditLogFields = ['AudTime', 'LastModificationDate', 'StartDate', 'CreationDate'];

      for (const auditLogTable of this.auditLog) {
        for (const auditLogTableField of auditLogTable.FieldsAudit) {
          if (dateAuditLogFields.includes(auditLogTableField.Field)) {
            auditLogTableField.Before = this.formatDateToUserFormatAndTime(auditLogTableField.Before);
            auditLogTableField.After = this.formatDateToUserFormatAndTime(auditLogTableField.After);
          }
        }
      }

      return this.auditLog;
    },
  },
};
</script>

<style scoped>
div >>> .modal-dialog {
  max-width: 800px;
}

div >>> .modal-title {
  font-size: 24px;
}

div >>> .modal-body {
  max-height: 500px;
}

div >>> .modal-footer__button-secondary {
  border-radius: 4px;
  padding: inherit;
  background: #e30613;
  line-height: 16px;
}
</style>
